import { FC } from "react";

import { RideRouteCompletionStatusEnum } from "@ryde/shared";

import { RideRouteCompletionStatusBadge } from "../../grid/cell-templates/rides/ride-route-completion-status-badge";
import { IRenderColumnTemplate } from "./_core";

export const RideRouteCompletionStatusCellTemplate: FC<
  IRenderColumnTemplate
> = ({ value }) => {
  const status =
    (value as RideRouteCompletionStatusEnum | "" | undefined) || undefined;

  return <RideRouteCompletionStatusBadge status={status} />;
};
